export default "__VITE_ASSET__bmBQp6d3__"